export { default } from './PartnerSettingsPage';
